import { useState } from "react";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import FloatingViki from "./FloatingViki";

export const AppShell = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div className="min-h-screen bg-canvas text-white overflow-x-hidden">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="md:pl-60 pb-[env(safe-area-inset-bottom)]">
        <Header onToggleSidebar={() => setSidebarOpen((o) => !o)} />
        {children}
      </div>
      <FloatingViki />
    </div>
  );
};
